import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { ViewStateService } from './view-state.service';

@Injectable()
export class NavGuardService implements CanActivate {

  constructor(private viewState: ViewStateService) { }

  canActivate() {
    if (this.viewState.CurrentViewState.isLoading) return false;
    return true;
  }
}
